import React, { useState } from 'react';
import service from './services/service'
import { useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import { Divider } from 'primereact/divider';
import { Skeleton } from 'primereact/skeleton';
import { Message } from 'primereact/message';
export const ColumnManagement = (props) => {

    const [typeDefs, setTypeDefs] = useState([]);
    const [rows, setRows] = useState([]);
    const [allRows, setAllRows] = useState([]);
    const [isValid, setIsValid] = useState(false);
    const [tableName, setTableName] = useState(null);
    const [prevValue, setPrevValue] = useState('');
    const [isLayer, setIsLayer] = useState(false);
    const [layerName, setLayerName] = useState(null);
    const [selectedTableType, setSelectedTableType] = useState(null);
    useEffect(() => {
        if (props.table) {
            getTypeDefs();
        }

        window["dynamicTableApiToken"] = props.tokenKey;

        if (props.table) {
            getColumns(props.table.id);

            setTableName(props.table.fullName);       

            if (props.tableTypes && props.tableTypes.length > 0) { 
                setSelectedTableType(props.tableTypes.find(x => x.type === props.table.tableType));
            }
        }

    }, []);

    const getColumns = (tableId) => {

        service.get(props.apiUrl + "/CustomerTable/GetTableColumns?_tableId=" + tableId).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                return;
            }

            setRows(response.data.filter(x => x.userAdded).map(x => ({
                name: x.name,
                type: x.type,
                required: x.isRequired,
                isActive: true,
                id: x.id,

            })));

            if (props.tableTypes && props.tableTypes.length > 0) {

                setAllRows(props.tableTypes.find(x => x.type === props.table.tableType)?.defaultColumns);
            }
            else {
                setAllRows([]);
            }

            getTableLayerName(tableId);

        });
    }
    const getTableLayerName = (tableId) => {
        service.get(props.apiUrl + "/CustomerTable/GetTableLayerName?_tableId=" + tableId).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                return;
            }

            setLayerName(response.data);
        });

    }
    const getTypeDefs = (e) => {
        service.get(props.apiUrl + "/CustomerTable/GetColumnType").then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                return;
            }
            if (props.table && props.table.tableType === 1) {

                response.data = response.data.filter(i => i.name != "Geometry");


            }

            if (!props.table && e.alias === "tree") {

                response.data = response.data.filter(i => i.name != "Geometry");

            }
            setTypeDefs(response.data.map(x => ({ name: x.name, fullName: `${x.name}  (${x.description})` })));
        }).catch(e => {
            console.log(e);
        });
    }
    const rowDelete = (row) => {
        setIsLayer(false);
        setIsValid(false);
        let rowsTemp = [...rows];
        rowsTemp = rowsTemp.filter(x => x !== row);
        setRows(rowsTemp);
        isValidTable(rowsTemp);
    }
    const rowChangeValue = (index, field, value) => {

        setIsLayer(false);
        setIsValid(false);
        let rowsTemp = [...rows];
        if (field === "name") {
            if (rows.find(x => x.name === value)) {
                setIsValid(rowsTemp);
            }
        }
        rowsTemp[index]["className"] = "";
        rowsTemp[index][field] = value;
        setRows(rowsTemp);

        isValidTable(rowsTemp);

    }

    const addRow = () => {
        setIsLayer(false);
        let rowsTemp = [...rows];
        rowsTemp.push({ name: '', type: '', required: false, className: "", isActive: true, isCompulsory: false, isDefaultColumn: false });
        setRows(rowsTemp);
        setIsValid(false);
    }
    const isValidTable = (rowsTemp) => {

        let columns = rowsTemp.find(x => x.name === '' || x.type === '');
        if (columns || !tableName) {
            setIsValid(false);
            return;
        }
        setIsValid(true);
    }
    const saveTable = () => {

        let columns = rows.map(x => ({ type: x.type.name ? x.type.name : x.type, name: x.name, isRequired: x.required, isDefaultColumn: x.isDefaultColumn }));

        service.post(props.apiUrl + "/CustomerTable/Add", { name: selectedTableType.alias + "_" + tableName, columns: columns, isCustomer: true, tableType: selectedTableType.type, layerName: layerName }).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                props.toast.current.show({ severity: 'error', summary: 'Hata', detail: response.message });
                return;
            }
            props.toast.current.show({ severity: 'success', summary: 'Bilgi', detail: "Tablo eklendi" });
            props.onComplete();

            if (selectedTableType.type === 1) {

                addLayer(response.data);
                addLayerForPoi(response.data);
            }

            if (isLayer && layerName ) {
                addLayer(response.data);
            }

        });
    }

    const updateTable = () => {

        let columns = rows.map(x => ({ type: x.type.name ? x.type.name : x.type, name: x.name, isRequired: x.required, isDefaultColumn: x.isDefaultColumn }));

        service.post(props.apiUrl + "/CustomerTable/Update", { tableId: props.table.id, name: tableName, columns: columns, layerName: layerName }).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                props.toast.current.show({ severity: 'error', summary: 'Hata', detail: response.message });
                return;
            }
            props.toast.current.show({ severity: 'success', summary: 'Bilgi', detail: "Değişikler kaydedildi" });
            props.onComplete();

        }).catch(e => {
            console.log(e);
        });
    }
    //Oluşturulan tabloyu geoservere katman olarak ekle
    const addLayer = (tableId) => {

        service.get(props.apiUrl + "/DynamicLayer/CreateLayer?_tableId=" + tableId).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                props.toast.current.show({ severity: 'error', summary: 'Hata', detail: response.message });
                return;
            }

        }).catch(e => {
            console.log(e);
        });
    }
    const addLayerForPoi = (tableId) => {

        service.get(props.apiUrl + "/DynamicLayer/CreateLayerForPoi?_tableId=" + tableId).then(response => {
            if (response === "") {
                return;
            }
            if (!response.success) {
                props.toast.current.show({ severity: 'error', summary: 'Hata', detail: response.message });
                return;
            }

        }).catch(e => {
            console.log(e);
        });
    }
    const validateInput = (event, validatePattern) => {
        const target = event.target;

        if (validatePattern) {
            if (target.value.length > 0) {
                setPrevValue(target.value);
            }

            return;
        }

        if (target.value.length > 0) {

            target.value = prevValue;
        }
    }
    const isCompulsoryAction = (row) => {

        if (!props.table) {
            return row.isCompulsory;
        }
        let table = props.tableTypes.find(x => x.type === props.table.tableType);;
        if (table) {
            return table.defaultColumns.some(x => x.type === row.type && x.name === row.name);
        }
        return false;

    }

    if (props.table && rows.length < 1 && allRows.length < 1) {
        return (<>
            <Skeleton className="mb-2"></Skeleton>
            <Skeleton width="10rem" className="mb-2"></Skeleton>
            <Skeleton width="5rem" className="mb-2"></Skeleton>
            <Skeleton height="2rem" className="mb-2"></Skeleton>
            <Skeleton width="10rem" height="4rem"></Skeleton>
        </>)
    }

    return (
        <div id={props.id} style={{ overflowY: 'auto', overflowX: 'hidden', maxHeight: '85vh' }}>
            <div className="card" >


                <div className="grid p-fluid" >
                    <div className="col-12 md:col-8">
                        <div className="p-inputgroup">
                            <Button tooltip="Tablo Listesine Geri Dön" icon="pi pi-angle-left" onClick={props.onComplete} iconPos="right" />


                            <InputText tooltip="Türkçe karakter kullanılmamaktadır" disabled={props.table} variant="filled" id="spacekey" keyfilter={/[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/} value={tableName} placeholder="Tablo Adı giriniz (*)" onChange={(e) => {
                                setTableName(e.target.value);
                                if (e.target.value.length < 1) {
                                    setRows([]);
                                }
                            }
                            } className={tableName == null ? "p-invalid" : ""} />
                            {tableName && tableName.length && tableName.length > 0 && <Dropdown disabled={props.table} value={selectedTableType} onChange={(e) => {

                                setIsValid(false);
                                setRows([]);
                                setTimeout(() => {

                                    setSelectedTableType(e.value);
                                    getTypeDefs(e.value);

                                    if (e.value.defaultColumns && e.value.defaultColumns.length > 0) {
                                        setIsValid(true);
                                        setRows(e.value.defaultColumns);
                                    }

                                }, 100);

                            }} options={props.tableTypes} optionLabel="name"
                                placeholder="Tablo Tipi seçiniz" className="w-full md:w-14rem" />}




                        </div>
                    </div>
                </div>
                { allRows.filter(x => x.isActive).map((row, i) => <div className={"grid p-fluid columnRow " + (isCompulsoryAction(row) ? "disabledDiv" : "")}>
                    <div className="col-12 md:col-4">
                        <div className="p-inputgroup">

                            <span className="p-inputgroup-addon">Kolon Adı</span>
                            <InputText tooltipOptions={{ position: 'left' }} tooltip="Türkçe karakter kullanılmamaktadır" keyfilter={/[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/} placeholder="Kolon Adı" value={row.name} className={row.className} onChange={(e) => {

                                rowChangeValue(i, 'name', e.target.value);

                            }} />
                        </div>
                    </div>

                    <div className="col-12 md:col-4">
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">Kolon Tipi</span>
                            <Dropdown options={typeDefs} value={typeDefs.find(x => x.name === row.type) ? typeDefs.find(x => x.name === row.type) : row.type} onChange={(e) => {
                                rowChangeValue(i, 'type', e.value);

                            }} optionLabel="fullName" placeholder="Kolon Tipi" />
                        </div>
                    </div>
                    {/*<div className="col-12 md:col-3">*/}
                    {/*    <div className="p-inputgroup">*/}

                    {/*        <Dropdown options={typeDefs} optionLabel="name" placeholder="Select a City" />*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="col-12 md:col-2">
                        <div className="p-inputgroup">

                            <Checkbox name="requred" checked={row.required} onChange={(e) => {

                                rowChangeValue(i, 'required', e.checked)

                            }} />
                            <label htmlFor="ingredient1" className="ml-2">Zorunlu</label>
                        </div>
                    </div>
                    <div className="col-12 md:col-2">
                        <div className="p-inputgroup">

                            <Button icon="pi pi-times" label="Kolonu sil" aria-label="Cancel" severity="danger" onClick={() => {

                                rowDelete(row);
                            }} />


                        </div>
                    </div>
                </div>)}

                {rows.filter(x => x.isActive).map((row, i) => <div className={"grid p-fluid columnRow " + (isCompulsoryAction(row) ? "disabledDiv" : "")}>
                    <div className="col-12 md:col-4">
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">Kolon Adı</span>
                            <InputText tooltipOptions={{ position: 'left' }} tooltip="Türkçe karakter kullanılmamaktadır" keyfilter={/[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/} placeholder="Kolon Adı" value={row.name} className={row.className} onChange={(e) => {
                                rowChangeValue(i, 'name', e.target.value);

                            }} />
                        </div>
                    </div>

                    <div className="col-12 md:col-4">
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon">Kolon Tipi</span>
                            <Dropdown options={typeDefs} value={typeDefs.find(x => x.name === row.type) ? typeDefs.find(x => x.name === row.type) : row.type} onChange={(e) => {
                                rowChangeValue(i, 'type', e.value);

                            }} optionLabel="fullName" placeholder="Kolon Tipi" />
                        </div>
                    </div>
                    {/*<div className="col-12 md:col-3">*/}
                    {/*    <div className="p-inputgroup">*/}

                    {/*        <Dropdown options={typeDefs} optionLabel="name" placeholder="Select a City" />*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="col-12 md:col-2">
                        <div className="p-inputgroup">

                            <Checkbox name="requred" checked={row.required} onChange={(e) => {

                                rowChangeValue(i, 'required', e.checked)

                            }} />
                            <label htmlFor="ingredient1" className="ml-2">Zorunlu</label>
                        </div>
                    </div>
                    <div className="col-12 md:col-2">
                        <div className="p-inputgroup">

                            <Button tooltip={props.table ? "Kolonu silmek veri kayıplarına sebep alabilir" : ""} tooltipOptions={{ position: 'left' }} icon="pi pi-times" label="Kolonu sil" aria-label="Cancel" severity="danger" onClick={() => {

                                rowDelete(row);
                            }} />


                        </div>
                    </div>
                </div>)}




                {selectedTableType && tableName && < Button disabled={!tableName} label="Kolon Ekle" icon="pi pi-plus" onClick={addRow} iconPos="right" />}

                <br />

            </div>



            {!props.table && selectedTableType && rows.find(x => x.type === "Geometry" || (x.type.name && x.type.name === 'Geometry')) != null &&
                <>
                    <Divider />
                    <div className="flex align-items-center">

                        <Checkbox inputId="ingredient1" name="pizza" value="Tabloyu oluştur ve katman kontrolüne ekle" onChange={(e) => {
                            setIsValid(!e.checked);
                            setIsLayer(e.checked);
                        }} checked={selectedTableType.type === 1 ? true : isLayer} />
                        <label htmlFor="ingredient1" className="ml-2">Katman kontrolüne ekle</label>
                    </div>
                </>
            }
            {isLayer && <>
                <Divider />
                <h3> Katman kontrolünde görmek isteğiniz ismi giriniz</h3>

                <InputText invalid={(!layerName || layerName === '' || layerName === null)} className="w-full" variant="filled" value={layerName} placeholder="Katman Adı" onChange={(e) => {

                    if (e.target.value.length < 1) {
                        setIsValid(false);
                    }
                    else {
                        setIsValid(true);

                    }
                    setLayerName(e.target.value)
                }

                } className={tableName == null ? "p-invalid" : ""} />

                {!layerName && isLayer && !props.table && selectedTableType && <Message style={{ marginLeft: "20px" }} severity="info" text="Katman adı zorunludur." />}
            </>
            }
            <Divider />
            {!props.table && tableName && <Button disabled={!isValid} label={"Tabloyu Ekle"} icon="pi pi-save" onClick={saveTable} iconPos="right" />}
            {props.table && tableName && <Button disabled={!isValid} label={"Değişiklikleri Kaydet"} icon="pi pi-save" onClick={updateTable} iconPos="right" />}
            {!isValid && !props.table && selectedTableType && <Message style={{ marginLeft: "20px" }} severity="info" text="Eklenen tüm kolonlar için kolon ismi ve tipi girilmelidir" />}


            {isValid && <Message severity="success" style={{ marginLeft: "20px" }} text="Tablo kaydedilebilir" />}



        </div>)

}

export default ColumnManagement;